import { ErrorPage } from '@/views/Facilities/CheckPermissions';

export const checkAdminPermission = ({
  permissionKey,
  childKey = 'viewPage',
  permission = 'read',
}) => {
  let adminPermissions = null;
  try {
    adminPermissions = JSON.parse(
      localStorage.getItem('adminPermissions') ?? 'null',
    );
  } catch {
    localStorage.removeItem('adminPermissions');
  }

  if (!adminPermissions) {
    window.location.href = '/user/login';
    return false;
  }

  return (
    adminPermissions?.[permissionKey]?.[childKey]?.includes(permission) ?? false
  );
};

export default function CheckAdminPermissionsComponent({
  permissionKey,
  childKey = 'viewPage',
  permission = 'read',
  children,
}) {
  const isAllowed = checkAdminPermission({
    permissionKey,
    childKey,
    permission,
  });

  return (
    <>
      {isAllowed ? (
        children
      ) : (
        <ErrorPage childKey={childKey === 'viewPage' ? undefined : childKey} />
      )}
    </>
  );
}
